import { render, staticRenderFns } from "./ProformaConsulta.vue?vue&type=template&id=7c1bcd2b&"
import script from "./ProformaConsulta.vue?vue&type=script&lang=js&"
export * from "./ProformaConsulta.vue?vue&type=script&lang=js&"
import style0 from "./ProformaConsulta.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ProformaConsulta.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports